<template>
  <div v-bind:style="{ fontFamily: this.template_configuration.selected_font + ', sans-serif !important' }">
    <!-- Headers conditional section -->
    <header-one v-if="this.template_configuration.header_style == 1" :settings_style="this.template_configuration" :quote_data="quote_data"></header-one>
    <header-two v-if="this.template_configuration.header_style == 2" :settings_style="this.template_configuration" :quote_data="quote_data"></header-two>
    <header-three v-if="this.template_configuration.header_style == 3" :settings_style="this.template_configuration" :quote_data="quote_data"></header-three>
    <header-four v-if="this.template_configuration.header_style == 4" :settings_style="this.template_configuration" :quote_data="quote_data"></header-four>

    <!-- Info conditional section -->
    <info-one v-if="this.template_configuration.info_style == 1" :settings_style="this.template_configuration" :quote_data="quote_data"></info-one>
    <info-two v-if="this.template_configuration.info_style == 2" :settings_style="this.template_configuration" :quote_data="quote_data"></info-two>
    <info-three v-if="this.template_configuration.info_style == 3" :settings_style="this.template_configuration" :quote_data="quote_data"></info-three>
    <info-four v-if="this.template_configuration.info_style == 4" :settings_style="this.template_configuration" :quote_data="quote_data"></info-four>

    <!-- Title conditional section -->
    <title-one v-if="this.template_configuration.title_style == 1" :settings_style="this.template_configuration" :quote_data="quote_data"></title-one>
    <title-two v-if="this.template_configuration.title_style == 2" :settings_style="this.template_configuration" :quote_data="quote_data"></title-two>
    <title-three v-if="this.template_configuration.title_style == 3" :settings_style="this.template_configuration" :quote_data="quote_data"></title-three>
    <title-four v-if="this.template_configuration.title_style == 4" :settings_style="this.template_configuration" :quote_data="quote_data"></title-four>

    <!-- Body conditional section -->
    <body-one v-if="this.template_configuration.items_style == 1" :settings_style="this.template_configuration" :quote_data="quote_data"></body-one>
    <body-two v-if="this.template_configuration.items_style == 2" :settings_style="this.template_configuration" :quote_data="quote_data"></body-two>
    <body-three v-if="this.template_configuration.items_style == 3" :settings_style="this.template_configuration" :quote_data="quote_data"></body-three>
    <body-four v-if="this.template_configuration.items_style == 4" :settings_style="this.template_configuration" :quote_data="quote_data"></body-four>
  </div>

</template>
<script>

/* Import of headers */
import headerOne from "@/components/pdf/headers/headerOne";
import headerTwo from "@/components/pdf/headers/headerTwo";
import headerThree from "@/components/pdf/headers/headerThree";
import headerFour from "@/components/pdf/headers/headerFour";
/* Import of info */
import infoOne from "@/components/pdf/info/infoOne";
import infoTwo from "@/components/pdf/info/infoTwo";
import infoThree from "@/components/pdf/info/infoThree";
import infoFour from "@/components/pdf/info/infoFour";
/* Import of title */
import titleOne from "@/components/pdf/title/titleOne";
import titleTwo from "@/components/pdf/title/titleTwo";
import titleThree from "@/components/pdf/title/titleThree";
import titleFour from "@/components/pdf/title/titleFour";
/* Import of body */
import bodyOne from "@/components/pdf/body/bodyOne";
import bodyTwo from "@/components/pdf/body/bodyTwo";
import bodyThree from "@/components/pdf/body/bodyThree";
import bodyFour from "@/components/pdf/body/bodyFour";

export default {
  components:{
    headerOne,
    headerTwo,
    headerThree,
    headerFour,
    infoOne,
    infoTwo,
    infoThree,
    infoFour,
    titleOne,
    titleTwo,
    titleThree,
    titleFour,
    bodyOne,
    bodyTwo,
    bodyThree,
    bodyFour,
  },

  props: {
    template_configuration: { required: true },
    quote_data: { type: Object }
  }
};
</script>
